module.exports = __webpack_public_path__ + "img/main-pic.2bd7692d.png";